import type { ProfileResponse } from "@circle-react/hooks/profile/useProfileInfo";
import { Suspense } from "react";

import { RailProfile as RailProfileLoader } from "@/react/components/shared/uikit/SkeletonLoader/skeletons/Rail/RailProfile";
import { lazyWithRetry } from "@/react/helpers/lazyRetry";
import type { ChatRoom } from "@/react/types/Chat/ChatRoom";

import { MemberList } from "./MemberList";

const CompactProfileV4 = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "CompactProfileV4" */ "@circle-react/components/ProfileModalV4/CompactProfile"
  ).then(module => ({ default: module.CompactProfileV4 })),
);

interface ContentProps {
  chatRoom: ChatRoom;
  description: string;
  isDirect: boolean;
  member: ProfileResponse;
  onClose: () => void;
  refetchChatRoom: () => void;
  refetchProfileInfo: () => void;
}

export const Content = ({
  chatRoom,
  isDirect,
  refetchChatRoom,
  member,
  refetchProfileInfo,
  description,
  onClose,
}: ContentProps) => {
  if (isDirect) {
    const refetch = () => {
      refetchProfileInfo();
      refetchChatRoom();
    };

    return (
      <Suspense fallback={<RailProfileLoader />}>
        <CompactProfileV4
          member={member}
          isLoading={false}
          refetchProfileInfo={refetch}
          shouldHideMessageButton
          onClose={onClose}
        />
      </Suspense>
    );
  }
  return (
    <MemberList
      chatRoom={chatRoom}
      refetchChatRoom={refetchChatRoom}
      description={description}
    />
  );
};
